import { BidiModule } from "@angular/cdk/bidi";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { UiDropdownModule } from "../dropdown/dropdown.module";
import { UiGridModule } from "../grid/grid.module";
import { UiIconModule } from "../icon/icon.module";
import { UiButtonComponent } from "./button.component";
import { UiButtonGroupComponent } from "./components/button-group/button-group.component";
import { UiTransButtonDirective } from "./directives/ui-trans-button.directive";

@NgModule({
  imports: [CommonModule, BidiModule, LocalizationModule, UiIconModule, UiDropdownModule, UiGridModule],
  declarations: [UiButtonComponent, UiButtonGroupComponent, UiTransButtonDirective],
  exports: [UiButtonComponent, UiButtonGroupComponent, UiTransButtonDirective],
})
export class UiButtonModule {}
